export default __webpack_public_path__ + "static/media/home.d34bd8fa.png";